import {
  Home,
  Wrench,
  Zap,
  Wind,
  HardHat,
  Briefcase,
  Store,
  Settings,
  Heart,
  HelpCircle,
  Layers,
  type LucideIcon,
} from "lucide-react";

export interface NavItem {
  path: string;
  label: string;
  /** Shorter label used in the mobile tab bar */
  shortLabel?: string;
  icon: LucideIcon;
  desc: string;
}

/**
 * Three layers, five nav slots — forever.
 *   Home · Trades · Jobs · Shop · More
 *
 * A new calculator becomes a tab inside a trade page.
 * Anything with money, hours or a customer name becomes a tab inside Jobs.
 * Anything editable that more than one trade shares belongs in Shop.
 */

/** Trade hubs — calculators and reference only. This list is fixed. */
export const tradeNav: NavItem[] = [
  { path: "/pipe", label: "Pipe", icon: Wrench, desc: "Sizing, fittings, plumbing & offsets" },
  { path: "/electrical", label: "Electrical", shortLabel: "Electric", icon: Zap, desc: "Wire, conduit, motors & equipment" },
  { path: "/ductwork", label: "Ductwork", shortLabel: "Duct", icon: Wind, desc: "Duct sizing, airflow & HVAC/R" },
  { path: "/structural", label: "Structural", shortLabel: "Struct", icon: HardHat, desc: "Beams, anchors, seismic & loads" },
];

/** Bottom bar slots that go straight to a page. */
export const primaryNav: NavItem[] = [
  { path: "/", label: "Home", icon: Home, desc: "Search, favorites & recent tools" },
  { path: "/jobs", label: "Jobs", icon: Briefcase, desc: "Sketch, layout, estimate, reports & hours" },
  { path: "/shop", label: "Shop", icon: Store, desc: "Material prices & labor rates" },
];

/** The Trades slot opens this list. */
export const tradesMenu: NavItem[] = [
  { path: "/trades", label: "All trades", icon: Layers, desc: "Calculators, catalog & labor for every trade" },
  ...tradeNav,
];

/**
 * Everything else lives behind "More".
 * Sketch pads are reached from their trade (Trades page), and the saved
 * calculation log is the Hours tab inside Jobs — neither needs a nav slot.
 */
export const secondaryNav: NavItem[] = [
  { path: "/help", label: "Help & FAQ", icon: HelpCircle, desc: "Guides, shortcuts & answers" },
  { path: "/settings", label: "Settings", icon: Settings, desc: "Defaults, theme & preferences" },
  { path: "/support", label: "Value 4 Value", icon: Heart, desc: "Support Trades Toolbelt" },
];


/** Icon used by the Trades slot itself. */
export const tradesIcon: LucideIcon = Layers;
